<template>
  <DsShowcase title="DatePickerPlay" description="Seletor de intervalo de datas (wrapper do vue3-daterange-picker).">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>v-model: { startDate: Date, endDate: Date }</code></p>
      <div class="tw:max-w-lg tw:space-y-3">
        <DatePickerPlay v-model="dateRange" />
        <p class="tw:text-xs tw:opacity-50">
          {{ formatDate(dateRange.startDate) }} — {{ formatDate(dateRange.endDate) }}
        </p>
      </div>
    </section>

    <!-- PROP: showInput -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">showInput</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — exibe o campo de input. Padrão: <code>true</code></p>
      <p class="tw:text-xs tw:opacity-50">Quando <code>false</code>, esconde o input e mostra só o calendário.</p>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { DatePickerPlay } from '@/components/atomic'

const dateRange = ref({
  startDate: new Date(),
  endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
})

function formatDate(d: Date) {
  return d.toLocaleDateString('pt-BR')
}
</script>
